import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { MergeRequest } from "./merge-request";
import { LabMDM } from '../masterdata/models/lab';
import { MergePrintRequest } from "./merge-print-request";
import { timeout, tap } from 'rxjs/operators';
import { EchoFileRequest } from './echo-file-request';

@Injectable()
export class ContainerMergeService {


    constructor(private http: HttpClient) {
    }

    /**
     * @description to start generate target barcode and print
     * @param mergeRequest object
    */
   generatePrintBarcodes(mergeRequest: MergeRequest): Observable<BBResponseContainer> {

    let url = environment.BB_SEQUENCING_SERVICE_URL + 'container/merge/generateTargetBarcode'
    return this.http.post<BBResponseContainer>(url, mergeRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
}

    /**
     * @description to start merging Containers
     * @param mergeRequest object
    */
    startMergingContainers(mergeRequest: MergeRequest): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'container/merge/start'
        return this.http.post<BBResponseContainer>(url, mergeRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    /**
     * @description to complete merging Containers
     * @param mergeRequest object
    */
    completeMergingContainers(mergeRequest: MergeRequest): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'container/merge/complete'
        return this.http.post<BBResponseContainer>(url, mergeRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

     public generateHamiltonFile(mergeRequest: MergeRequest): Observable<any> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'container/merge/generateHamiltonFile'
        return this.http.post(url, mergeRequest, {responseType:'blob'}).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    public generateEchoFile(echoFileRequest:EchoFileRequest): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'container/echofile/generateEchoFile';
        return this.http.post<BBResponseContainer>(url, echoFileRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //shared Methods
    // Observable string sources
    private emitChangeSource = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(change: any) {
        console.log("emit change");
        this.emitChangeSource.next(change);
    }



    validateBarcode(inputBarcode: string, lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'container/merge/validatebarcode';
        let requestParam = new HttpParams().set('inputBarcode', inputBarcode.toString())
        .set('labId', lab._id);

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
          error.url = url;
        }));
    }


    public printBarcode(mergePrintRequest: MergePrintRequest): Observable<BBResponseContainer> {
        console.log(mergePrintRequest.lab);
        console.log(mergePrintRequest.inputBarcode);
        console.log(mergePrintRequest.printBarcodeType);
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'container/merge/printbarcode';

        return this.http.post<BBResponseContainer>(url, mergePrintRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

}
